"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderFragmentsWithBos = exports.minimalOrderFragments = exports.orderFragments = exports.orderApplicationStatusFragments = exports.orderApplicationStatusFragment = exports.orderFaunaFragment = exports.orderFragment = exports.findOrderByIdFragment = exports.leadFragment = exports.getOrderFragment = void 0;
const contract_1 = require("./contract");
const accessory_1 = require("./accessory");
const comment_1 = require("./comment");
const calculation_1 = require("./calculation");
const customer_1 = require("./customer");
const financing_1 = require("./financing");
const document_1 = require("./document");
const insurance_1 = require("./insurance");
const reference_1 = require("./reference");
const user_1 = require("./user");
const tradeIn_1 = require("./tradeIn");
const vehicle_1 = require("./vehicle");
const order_1 = require("../order");
const pim_snapshot_1 = require("./pim-snapshot");
const finance_1 = require("../../finance");
const margin_1 = require("./margin");
const order_event_1 = require("./order-event");
const getOrderFragment = (fields) => `
  fragment order on Order {
    ${fields}
  }
`;
exports.getOrderFragment = getOrderFragment;
exports.leadFragment = `
  fragment lead on Lead {
    customerId
    make
    modelSeries
    quoteId
  }
`;
exports.findOrderByIdFragment = (0, exports.getOrderFragment)(order_1.findOrderByIdFields);
exports.orderFragment = (0, exports.getOrderFragment)(order_1.orderAllFields);
exports.orderFaunaFragment = (0, exports.getOrderFragment)(order_1.orderFaunaFields);
exports.orderApplicationStatusFragment = (0, exports.getOrderFragment)(order_1.orderApplicationStatusFields);
exports.orderApplicationStatusFragments = `
  ${exports.orderApplicationStatusFragment}
  ${finance_1.applicationStatusFragment}
`;
exports.orderFragments = `
  ${accessory_1.accessoryFragment}
  ${calculation_1.calculationFragment}
  ${comment_1.commentFragment}
  ${contract_1.contractFragment}
  ${customer_1.customerFragment}
  ${document_1.documentFragment}
  ${financing_1.financingFragmentFull}
  ${financing_1.financingRequestFragment}
  ${insurance_1.insuranceFragment}
  ${insurance_1.insuranceTransferFragment}
  ${margin_1.marginFragment}
  ${exports.orderFragment}
  ${exports.leadFragment}
  ${order_event_1.orderEventFragment}
  ${pim_snapshot_1.pimSnapshotFragment}
  ${reference_1.referenceFragment}
  ${vehicle_1.reserveDetailsFragment}
  ${tradeIn_1.tradeInFragment}
  ${user_1.userFragment}
  ${vehicle_1.vehicleConfigurationFragment}
  ${vehicle_1.vehicleFragment}
  ${vehicle_1.vehicleInventoryFragment}
  ${vehicle_1.vehicleModelFragment}
  ${vehicle_1.vehicleOptionFragment}
  ${vehicle_1.vehicleOrderStatusFragment}
  ${vehicle_1.vehicleStatusFragment}
`;
exports.minimalOrderFragments = `
  ${accessory_1.accessoryFragment}
  ${calculation_1.calculationFragment}
  ${comment_1.commentFragment}
  ${contract_1.contractFragment}
  ${customer_1.customerFragment}
  ${document_1.documentFragment}
  ${financing_1.financingFragmentFull}
  ${financing_1.financingRequestFragment}
  ${insurance_1.insuranceFragment}
  ${insurance_1.insuranceTransferFragment}
  ${margin_1.marginFragment}
  ${exports.orderFaunaFragment}
  ${exports.leadFragment}
  ${pim_snapshot_1.pimSnapshotFragment}
  ${reference_1.referenceFragment}
  ${vehicle_1.reserveDetailsFragment}
  ${tradeIn_1.tradeInFragment}
  ${user_1.userFragment}
  ${vehicle_1.vehicleFragmentMinimal}
  ${vehicle_1.vehicleModelFragment}
  ${vehicle_1.vehicleOptionFragment}
`;
exports.orderFragmentsWithBos = `
  ${accessory_1.accessoryFragment}
  ${customer_1.bosCustomerFragmentMinimal}
  ${calculation_1.calculationFragment}
  ${comment_1.commentFragment}
  ${contract_1.contractFragment}
  ${customer_1.customerFragmentWithBosMinimal}
  ${document_1.documentFragment}
  ${financing_1.financingFragmentFull}
  ${financing_1.financingRequestFragment}
  ${insurance_1.insuranceFragment}
  ${insurance_1.insuranceTransferFragment}
  ${margin_1.marginFragment}
  ${exports.orderFragment}
  ${exports.leadFragment}
  ${order_event_1.orderEventFragment}
  ${pim_snapshot_1.pimSnapshotFragment}
  ${reference_1.referenceFragment}
  ${vehicle_1.reserveDetailsFragment}
  ${tradeIn_1.tradeInFragment}
  ${user_1.userFragment}
  ${vehicle_1.vehicleConfigurationFragment}
  ${vehicle_1.vehicleFragment}
  ${vehicle_1.vehicleInventoryFragment}
  ${vehicle_1.vehicleModelFragment}
  ${vehicle_1.vehicleOptionFragment}
  ${vehicle_1.vehicleOrderStatusFragment}
  ${vehicle_1.vehicleStatusFragment}
`;
//# sourceMappingURL=order.js.map